import { organizationRoutes } from "@/features/organization";

export const createPermissionOverrides = () => ({
  mode: "inherit",
  allow: [],
  deny: [],
});

export const createCreateForm = () => ({
  displayName: "",
  username: "",
  email: "",
  role: "",
  customRoleName: "",
  organizationUnitId: [],
  assignedToParentCompany: false,
  companyId: "",
  permissionOverrides: createPermissionOverrides(),
  email2FAEnabled: false,
});

export const createEditForm = () => ({
  name: "",
  username: "",
  email: "",
  role: "",
  customRoleName: "",
  status: "",
  organizationUnitId: [],
  assignedToParentCompany: false,
  //organizationUnitName: "",
  companyId: "",
  permissionOverrides: createPermissionOverrides(),
});

export const createMeta = () => ({
  company: "",
  createdAt: null,
  updatedAt: null,
});

export const createListFilters = () => ({
  username: "",
  email: "",
  company: "",
  org: "",
  role: "",
});

export const createListSort = () => ({
  key: "",
  direction: "asc",
});

export const normalizePermissionOverrides = (value) => {
  if (!value || typeof value !== "object") {
    return createPermissionOverrides();
  }
  const normalized = {
    mode: value.mode === "override" ? "override" : "inherit",
    allow: Array.isArray(value.allow) ? value.allow : [],
    deny: Array.isArray(value.deny) ? value.deny : [],
  };
  if (
    typeof value.roleId === "string" ||
    typeof value.roleId === "number" ||
    (value.roleId && typeof value.roleId === "object")
  ) {
    normalized.roleId = value.roleId;
  }
  return normalized;
};

export const resolvePayload = (data) => {
  if (!data) return null;
  if (data && typeof data === "object" && "data" in data) {
    return data.data;
  }
  return data;
};

export const resolveRelativeTime = (value) => {
  if (!value) return null;
  const timestamp =
    typeof value === "string" || typeof value === "number"
      ? new Date(value)
      : value;
  if (Number.isNaN(timestamp.getTime())) return null;
  const seconds = Math.round((Date.now() - timestamp.getTime()) / 1000);
  const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

  if (seconds < 60) return rtf.format(-seconds, "second");
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return rtf.format(-minutes, "minute");
  const hours = Math.round(minutes / 60);
  if (hours < 24) return rtf.format(-hours, "hour");
  const days = Math.round(hours / 24);
  if (days < 30) return rtf.format(-days, "day");
  const months = Math.round(days / 30);
  if (months < 12) return rtf.format(-months, "month");
  const years = Math.round(months / 12);
  return rtf.format(-years, "year");
};
